import useSWR from 'swr';
import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxAvailableRegistrationsV2Params,
  IIndirectTaxAvailableRegistrationsV2Response,
} from './types';

export function useIndirectTaxAvailableRegistrations(
  params: IIndirectTaxAvailableRegistrationsV2Params | null
) {
  const key = params
    ? ['new-sales-tax/registrations-v2/content/available-registrations', params]
    : null;

  const { data, error, isLoading, mutate } = useSWR<IIndirectTaxAvailableRegistrationsV2Response>(
    key,
    async ([url, body]) => {
      const response = await fetcher(url as string, { method: 'POST', body });
      if (!response.ok) throw new Error('Failed to fetch available registrations');
      return response.json();
    }
  );

  return {
    data: data?.registrations ?? [],
    error,
    isLoading,
    mutate,
  };
}
